import React from "react";
import { ActivityIcon } from "lucide-react";
import { images } from "../../data/content";
import { OfferBlock } from "../OfferBlock";
export function Hero() {
  return <header className="bg-cream px-5 pb-14 pt-7 md:pt-12" data-id="element-194" data-mp="cvulk3bkgbn4">
      <div className="mx-auto max-w-4xl text-center" data-id="element-195" data-mp="cu9ski4wh0rd">
        <div className="inline-flex items-center gap-2.5" data-id="element-196" data-mp="hunynumxy0mr">
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-navy text-gold" data-id="element-197" data-mp="hsusshk5jkft">
            <ActivityIcon className="h-5 w-5" aria-hidden="true" data-id="element-198" data-mp="mtsayu55wehb" />
          </span>
          <span className="font-serif text-lg font-black text-navy md:text-xl" data-id="element-199" data-mp="qub18jrepche">
            Abdominoplasty Master System™
          </span>
        </div>

        <h1 className="mt-7 font-serif text-[38px] font-black leading-[1.05] text-navy md:text-6xl lg:text-7xl" data-id="element-200" data-mp="10l5s61fll096">
          Analyze Any Educational Abdominoplasty Case in{" "}
          <em className="italic text-gold-dark" data-id="element-201" data-mp="15ifgfdr935vf">15 Minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-navy/75 md:text-xl" data-id="element-202" data-mp="1ak4nyjf9l1er">
          A structured case-based professional training system designed to help plastic surgeons and aesthetic
          physicians organize their observations, identify the variables that matter, prioritize what deserves further
          review, and develop a more disciplined approach to preoperative case analysis.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[17px] leading-relaxed text-navy md:text-xl" data-id="element-203" data-mp="3rvs7nkcji8ck">
          Includes <strong data-id="element-204" data-mp="nf7hs1hycemu">6 premium volumes</strong>, <strong data-id="element-205" data-mp="ng8v6cmfxd7q">5 professional bonuses</strong> and{" "}
          <strong data-id="element-206" data-mp="nhk1aj3cyx20">30+ case-review tools</strong>.
        </p>

        <img src={images.mockup} alt="The 6 volumes, 5 tools and 5 bonuses of The Abdominoplasty Master System" className="-mx-2 mt-8 w-[calc(100%+1rem)] max-w-none md:mx-auto md:w-full md:max-w-3xl" data-id="element-207" data-mp="imxxb0zlw6ry" />
        <p className="mt-3 text-xs font-extrabold uppercase tracking-[0.16em] text-gold-dark" data-id="element-208" data-mp="16e3bzctt8t0o">
          The 6 volumes + 5 bonuses inside the Abdominoplasty Master System™
        </p>

        <div className="mt-8" data-id="element-209" data-mp="30o0bthaexaci">
          <OfferBlock id="first-cta" label="I want the Abdominoplasty Master System" sub="Instant digital access · One-time payment of $27 · Lifetime access · 7-day guarantee" data-id="element-210" data-mp="35ljrmlmrdv6k" />
        </div>
      </div>
    </header>;
}